import React, { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

const TYPES = ["inaccurate_summary", "incorrect_attribution", "broken_link", "rights_issue", "other"];

export function ReportIssue({ article }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ type: "inaccurate_summary", message: "", email: "" });
  const [sending, setSending] = useState(false);
  const inp = "w-full px-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg outline-none focus:border-violet-300";

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/reports", { ...form, email: form.email || null, article_id: article.id, article_url: article.original_url });
      toast.success(t("report.sent"));
      setOpen(false);
      setForm({ type: "inaccurate_summary", message: "", email: "" });
    } catch { toast.error("Failed to submit. Please try again."); }
    finally { setSending(false); }
  };

  if (!open) {
    return (
      <button data-testid="report-issue-btn" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-500 hover:text-rose-600 transition-colors">
        <Flag size={13} /> {t("report.button")}
      </button>
    );
  }
  return (
    <form data-testid="report-issue-form" onSubmit={submit} className="border border-slate-200 rounded-xl p-5 bg-white space-y-3">
      <h3 className="font-display font-bold text-base">{t("report.title")}</h3>
      <select data-testid="report-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className={inp} aria-label={t("report.type")}>
        {TYPES.map((k) => <option key={k} value={k}>{t(`report.${k}`)}</option>)}
      </select>
      <textarea data-testid="report-message" required minLength={3} rows={3} placeholder={t("report.message")} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={inp} />
      <input data-testid="report-email" type="email" placeholder={t("report.email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inp} />
      <div className="flex items-center gap-3">
        <button data-testid="report-submit" disabled={sending} className="bg-violet-600 text-white text-sm font-semibold px-5 py-2 rounded-full hover:bg-violet-700 disabled:opacity-60">{t("report.submit")}</button>
        <button type="button" data-testid="report-cancel" onClick={() => setOpen(false)} className="text-sm text-slate-500 hover:text-slate-800">{t("report.cancel")}</button>
      </div>
    </form>
  );
}
